<template>
  <div class="app-download">
    <div class="app-download-info">
      <h2 class="title">Download the free app</h2>
      <p
        class="desc">
        Access the premium podcast app that offers access to shows from top creators you won’t find anywhere else, plus the ones you already love.</p>
      <appstore-links/>
      <div class="mobileapp">
        <img
          :src="srcSet('src', twoPhonesImgs)"
          :srcset="srcSet('srcset', twoPhonesImgs)">
      </div>
    </div>
    <div class="app-image">
      <img
        :src="srcSet('src', twoPhonesImgs)"
        :srcset="srcSet('srcset', twoPhonesImgs)">
    </div>
  </div>
</template>
<script>
import AppStoreLinks from './AppStoreLinks';
import twoPhones1x from '../assets/images/twoPhones_1x.png';
import twoPhones2x from '../assets/images/twoPhones_2x.png';
import twoPhones3x from '../assets/images/twoPhones_3x.png';

export default {
  name: 'AppDownload',
  components: {
    'appstore-links': AppStoreLinks,
  },
  data() {
    return {
      twoPhonesImgs: [twoPhones1x, twoPhones2x, twoPhones3x],
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.app-download {
  background-color: $brand;
  padding: 2% 22%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  .app-download-info {
    .title {
      font-family: $clearface-bold;
      font-size: 40px;
      letter-spacing: -0.8px;
    }
    .desc {
      line-height: 22px;
      letter-spacing: -0.2px;
      color: $black;
      max-width: 511px;
      text-overflow: ellipsis;
      font-weight: Favorit-light;
    }
    .mobileapp {
      display: none;
    }
    .appstore-images {
      margin: 34px 0 30px 0;
      img {
        &:first-child {
          margin-right: 16px;
        }
      }
    }
  }
  .app-image {
    max-width: 300px;
    position: relative;
    img {
      position: absolute;
      right: -93px;
      top: 23px;
    }
  }
}
@media (max-width: $lg) {
  .app-download {
    padding: 1% 16%;
  }
}
@media (max-width: $md) {
  .app-download {
    padding: 1% 7.5%;
    .app-download-info {
      .title {
        font-family: "ITC Clearface";
        font-size: 40px;
        letter-spacing: -0.8px;
      }
      .desc {
        line-height: 22px;
        letter-spacing: -0.2px;
        color: $black;
        max-width: 400px;
        text-overflow: ellipsis;
        font-weight: Favorit-light;
      }
      .appstore-images {
        margin: 34px 0 30px 0;
        img {
          &:first-child {
            margin-right: 16px;
          }
        }
      }
    }
    .app-image {
      img {
        right: 0;
      }
    }
  }
}
@media (max-width: $sm) {
  .app-download {
    max-height: 480px;
    padding-bottom: 0;
    .app-download-info {
      margin: 0 auto;
      text-align: center;
      .mobileapp {
        display: block;
      }
    }
    .app-image {
      display: none;
    }
  }
}
@media (max-width: $xs) {
  .app-download {
    .app-download-info {
    .title {
      font-size: 30px;
    }
    .appstore-images {
      img {
        margin: 0 0 !important;
      }
    }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/AppDownload.vue